import React from 'react';
import {
  ICompany,
  ICurrentUserQueryResult,
  ICurrentUserQueryVariables,
  IFullUserDetails,
  ISystemUser,
} from '../../graphql/schema/p4types';
import { QueryResult } from '@apollo/client/react/types/types';

type IAppContext = {
  company: ICompany;

  /**
   * @deprecated - Do not access fullUserDetails this way, use either:
   * const \{currentUser\} = useContext(UserContext);
   * or
   * const fullUserDetails = useFullUserDetails(); (Which internally does the above anyway).
   */
  fullUserDetails?: IFullUserDetails;
  user: ISystemUser;

  /**
   * Refetch the current system user (If we've changed user or settings that affect the current users settings, for eexample).
   * @param shouldResetRoutes - Reset system routes so they obey the permissions for the newly selected user.
   *                          - Passing 'false' may leave a user with access to (or no access to) options they wouldn't be expected to access.
   *                            This is not recommended, and should only be used to avoid data-loss (I.e. The Trade Counter elevate/demote).
   *                            (It should be removed longer term by a re-factor of how we handle route permissions).
   */
  refetchUser: (
    shouldResetRoutes: boolean
  ) => Promise<QueryResult<ICurrentUserQueryResult, ICurrentUserQueryVariables>>;
  toasterId: string;
};

const AppContext = React.createContext({} as IAppContext);
export default AppContext;
